import React from 'react';
import logomarca from '../../images/logomarca-rodape.png';

function Logorodape() {
  return <img src={logomarca} alt="Logomarca" className="mx-auto d-block w-75" />;
}

export default Logorodape;